// Srpski jezik za dayjs i na serveru.
// dayjs-nuxt ucitava jezik samo kao `import 'dayjs/locale/sr'` (bez koriscenja vrednosti), a to u serverskom
// produkcijskom build-u otpadne: dayjs.locale('sr') se tada tiho ignorise i nazivi meseci i dana su na engleskom
// (npr. linkovi /kalendar-dogadjaja/.../2026/october/1). Registracija preko objekta jezika ne moze da otpadne.
import sr from 'dayjs/locale/sr'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.$dayjs.locale(sr)
})
